import { c as _c } from "react/compiler-runtime";
import { graphql } from "@opensea/graphql";
import { TraitOffersFilterTableRowFragment } from "@/components/filters-side-panel/TraitOffersFilterSection/TraitOffersFilterTableRow.fragment";
import { COLLECTION_OFFERS_SORT } from "@/components/offers/collection/constants";
import { OfferAggregateTotalsFragment } from "@/components/offers/collection/OfferAggregateTotals.fragment";
import { Paginator } from "@/lib/pagination/paginator";
import { useSubscription } from "../../use-subscription";
const subscription = graphql(`
    subscription useTraitOfferAggregatesTotalSubscription(
      $collectionSlug: String!
    ) {
      traitOfferAggregatesTotal(collectionSlug: $collectionSlug) {
        id
        traitType
        traitValue
        bestOfferPrice {
          usd
        }
        maxValueInTick {
          usd
        }
        totalOffers
        ...OfferAggregateTotals
        ...TraitOffersFilterTableRow
      }
    }
  `, [OfferAggregateTotalsFragment, TraitOffersFilterTableRowFragment]);
class TraitOfferAggregatesTotalPaginator extends Paginator {
  getValues(item) {
    return [item.bestOfferPrice.usd, item.id];
  }
}
const traitOfferAggregatesTotalPaginator = new TraitOfferAggregatesTotalPaginator();
export function useTraitOfferAggregatesTotalSubscription(t0) {
  const $ = _c(4);
  const {
    variables,
    setItems
  } = t0;
  let t1;
  if ($[0] !== variables) {
    t1 = {
      query: subscription,
      variables
    };
    $[0] = variables;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== setItems) {
    t2 = msg => {
      const item = msg.traitOfferAggregatesTotal;
      setItems(prev => {
        const isRemove = prev.find(i => i.id === item.id) && item.totalOffers === 0;
        if (isRemove) {
          return traitOfferAggregatesTotalPaginator.remove(item, prev, COLLECTION_OFFERS_SORT);
        }
        return traitOfferAggregatesTotalPaginator.insertInOrder(item, prev, COLLECTION_OFFERS_SORT, {
          insertIntoLastPlace: true
        });
      });
    };
    $[2] = setItems;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useSubscription(t1, t2);
}